import { cn } from '@/lib/utils';

/**
 * The one segmented-toggle look (finance plan Task 10, M21): the Overview's chart/table toggle, the entry table's
 * segment and the Dashboard's scope switch share it, so they cannot drift. The pressed segment is tinted with the
 * primary colour and takes the primary text — the selected-item rule — never a border.
 *
 * Use: `<div role="group" aria-label="…" className={SEGMENT_GROUP}>` holding `<button type="button" aria-pressed
 * className={SEGMENT}>` children.
 */
export const SEGMENT_GROUP = 'inline-flex items-center gap-1 rounded-lg bg-[hsl(var(--h-muted))] p-1';

export const SEGMENT = cn(
  'inline-flex min-h-9 items-center justify-center gap-2 rounded-md px-3 text-sm font-medium',
  'text-[hsl(var(--h-muted-foreground))] hover:text-[hsl(var(--h-card-foreground))]',
  'aria-pressed:bg-[hsl(var(--h-primary)/0.1)] aria-pressed:text-[hsl(var(--h-primary))]',
);

/** The row the switcher is on: a primary tint and primary text, also while the pointer or the arrows are on it. */
export const SELECTED_OPTION = cn(
  'bg-[hsl(var(--h-primary)/0.1)] font-semibold text-[hsl(var(--h-primary))]',
  'data-[active]:bg-[hsl(var(--h-primary)/0.14)] data-[active]:text-[hsl(var(--h-primary))]',
);
